import { routes as bases } from '../configuracoes/bases'
import { routes as armacoes } from '../configuracoes/armacoes'
import { routes as adicoes } from '../configuracoes/adicoes'

export default [
  {
    path: '/configuracoes',
    name: 'Configuracoes',
    component: () => import(/* webpackChunkName: "Configuracoes" */ '../configuracoes/Configuracoes')
  },
  ...bases,
  ...armacoes,
  ...adicoes,
]



// WEBPACK FOOTER //
// ./src/pages/configuracoes/router.js